export function isDev() {
  return process.env.NEXT_PUBLIC_DEVELOPMENT_MODE === 'true'
}

export default function isQAorDev() {
  return isDev() || window?.QAMode
}